export default __webpack_public_path__ + "static/gift-card-4.url-dab56d19946d32bd4bd5cf0620890cd3.svg";